import {
  matchesType,
  registerFormatter,
} from '.';
import { markdownRenderers } from './renderers/markdown';
import { plainRenderers } from './renderers/plain';
import { xmlRenderers } from './renderers/xml';
import {
  CodexCategorySchema,
  CodexEntrySchema,
  SnippetSchema,
  NovelSchema,
  NovelSeriesSchema,
  NovelActSchema,
  NovelChapterSchema,
  NovelSceneSchema
} from '#/index';
import { OutlineTree, NovelLabel, PointOfView, CodexDetail } from '../types';

registerFormatter<CodexEntrySchema>({
  id: 'codexEntry',
  predicate: (value: unknown): value is CodexEntrySchema => matchesType(value, 'codexEntry'),
  renderers: {
    markdown: markdownRenderers.renderCodexEntryMarkdown,
    plain: plainRenderers.renderCodexEntryPlain,
    xml: xmlRenderers.renderCodexEntryXml,
  },
});

registerFormatter<CodexCategorySchema>({
  id: 'codexCategory',
  predicate: (value: unknown): value is CodexCategorySchema => matchesType(value, 'codexCategory'),
  renderers: {
    markdown: markdownRenderers.renderCodexCategoryMarkdown,
    plain: plainRenderers.renderCodexCategoryPlain,
    xml: xmlRenderers.renderCodexCategoryXml,
  },
});
// registerFormatter<CodexFieldSchema>({
//   id: 'codexField',
//   predicate: (value: unknown): value is CodexFieldSchema => matchesType(value, 'codexField'),
//   renderers: {
//     markdown: markdownRenderers.renderCodexFieldMarkdown,
//     plain: plainRenderers.renderCodexFieldPlain,
//     xml: xmlRenderers.renderCodexFieldXml,
//   },
// });
registerFormatter<SnippetSchema>({
  id: 'snippet',
  predicate: (value: unknown): value is SnippetSchema => matchesType(value, 'snippet'),
  renderers: {
    markdown: markdownRenderers.renderSnippetMarkdown,
    plain: plainRenderers.renderSnippetPlain,
    xml: xmlRenderers.renderSnippetXml,
  },
});
registerFormatter<OutlineTree>({
  id: 'outlineTree',
  predicate: (value: unknown): value is OutlineTree => matchesType(value, 'outlineTree'),
  renderers: {
    markdown: markdownRenderers.renderOutlineTreeMarkdown,
    plain: plainRenderers.renderOutlineTreePlain,
    xml: xmlRenderers.renderOutlineTreeXml,
  },
});
registerFormatter<NovelLabel>({
  id: 'novelLabel',
  predicate: (value: unknown): value is NovelLabel => matchesType(value, 'novelLabel'),
  renderers: {
    markdown: markdownRenderers.renderLabelMarkdown,
    plain: plainRenderers.renderLabelPlain,
    xml: xmlRenderers.renderLabelXml,
  },
});
registerFormatter<PointOfView>({
  id: 'pointOfView',
  predicate: (value: unknown): value is PointOfView => matchesType(value, 'pointOfView'),
  renderers: {
    markdown: markdownRenderers.renderPointOfViewMarkdown,
    plain: plainRenderers.renderPointOfViewPlain,
    xml: xmlRenderers.renderPointOfViewXml,
  },
});
registerFormatter<CodexDetail>({
  id: 'codexDetail',
  predicate: (value: unknown): value is CodexDetail => matchesType(value, 'codexDetail'),
  renderers: {
    markdown: markdownRenderers.renderCodexDetailMarkdown,
    plain: plainRenderers.renderCodexDetailPlain,
    xml: xmlRenderers.renderCodexDetailXml,
  },
});

registerFormatter<NovelSchema>({
  id: 'novel',
  predicate: (value: unknown): value is NovelSchema => matchesType(value, 'novel'),
  renderers: {
    markdown: markdownRenderers.renderNovelMarkdown,
    plain: plainRenderers.renderNovelPlain,
    xml: xmlRenderers.renderNovelXml,
  },
});
registerFormatter<NovelSeriesSchema>({
  id: 'novelSeries',
  predicate: (value: unknown): value is NovelSeriesSchema => matchesType(value, 'novelSeries'),
  renderers: {
    markdown: markdownRenderers.renderSeriesMarkdown,
    plain: plainRenderers.renderSeriesPlain,
    xml: xmlRenderers.renderSeriesXml,
  },
});
registerFormatter<NovelActSchema>({
  id: 'novelAct',
  predicate: (value: unknown): value is NovelActSchema => matchesType(value, 'novelAct'),
  renderers: {
    markdown: markdownRenderers.renderActMarkdown,
    plain: plainRenderers.renderActPlain,
    xml: xmlRenderers.renderActXml,
  },
});
registerFormatter<NovelChapterSchema>({
  id: 'novelChapter',
  predicate: (value: unknown): value is NovelChapterSchema => matchesType(value, 'novelChapter'),
  renderers: {
    markdown: markdownRenderers.renderChapterMarkdown,
    plain: plainRenderers.renderChapterPlain,
    xml: xmlRenderers.renderChapterXml,
  },
});
registerFormatter<NovelSceneSchema>({
  id: 'novelScene',
  predicate: (value: unknown): value is NovelSceneSchema => matchesType(value, 'novelScene'),
  renderers: {
    markdown: markdownRenderers.renderSceneMarkdown,
    plain: plainRenderers.renderScenePlain,
    xml: xmlRenderers.renderSceneXml,
  },
});